import React from 'react';
import { Icon } from '../../../../../../../../../ui-kit';
import { OptionsListElement } from '../../../Blocks/components/common/StyledEditables';

const AnchorLink = () =>
<OptionsListElement>
    <Icon name="link" color="white" size={24} />
  </OptionsListElement>;


export default AnchorLink;